/**
 * Which overview a pinned filter tab belongs to (PREC-3880).
 *
 * Pinned tabs are stored in a single per-user table (`list_overview_pinned_tab`) whose `filters`
 * column is an opaque JSON snapshot. The snapshot's *shape* differs per overview — the Lead List
 * overview stores `{ ownership, contentFilter, archivedView, sourceType?, search? }`, the Campaigns
 * overview stores `{ ownership, statusFilter, channelFilter, archivedView, sourceType?, search? }`
 * — so the scope is what lets each surface fetch only the snapshots it can actually parse.
 *
 * This is a hard requirement, not an optimisation: the web response schemas validate `filters`
 * against a scope-specific Zod schema, so a mixed-scope payload would fail validation and break
 * whichever overview received it.
 */
export enum PinnedTabScope {
	/** Lead List overview (`/lists`) — the original scope, and the default for legacy rows. */
	LIST = "list",
	/** Campaigns overview (`/campaigns`). */
	CAMPAIGN = "campaign",
}

/** Every valid scope value, for runtime validation at the API boundary. */
export const PINNED_TAB_SCOPES: PinnedTabScope[] = Object.values(PinnedTabScope);

/** The scope assumed when a caller or a stored row does not specify one. */
export const DEFAULT_PINNED_TAB_SCOPE = PinnedTabScope.LIST;
